// src/i18n/locales/de/admin.ts
// German translations for admin panel

export default {
  login: {
    title: 'Admin-Portal',
    subtitle: 'Sicherer Zugang nur für Administratoren',
    adminBadge: 'ADMIN',
    userLogin: 'Benutzer-Login',
    email: 'Admin E-Mail',
    emailPlaceholder: 'admin@nutribot.com',
    password: 'Admin-Passwort',
    passwordPlaceholder: 'Admin-Passwort eingeben',
    loginButton: 'Sicher einloggen',
    signingIn: 'Anmeldung läuft...',
    warning: 'Dies ist ein geschützter Bereich. Alle Zugriffsversuche werden protokolliert und überwacht.',
    features: {
      secure: 'Verschlüsselt',
      monitoring: '24/7 Überwachung',
      control: 'Volle Kontrolle',
    },
    errors: {
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'Ungültiges E-Mail-Format',
      passwordRequired: 'Passwort ist erforderlich',
      passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein',
      invalidCredentials: 'Ungültige E-Mail oder Passwort',
      notAdmin: 'Zugriff verweigert. Admin-Rechte erforderlich.',
      loginFailed: 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      unknownError: 'Ein unbekannter Fehler ist aufgetreten',
    },
    success: 'Admin-Anmeldung erfolgreich',
  },
  layout: {
    title: 'Admin-Dashboard',
    logoAdmin: 'Admin',
    logoPanel: 'Panel',
    subtitle: 'NutriBot Verwaltung',
    badgeTitle: 'Administrator',
    badgeSubtitle: 'Vollzugriff auf das System',
    adminBadge: 'ADMIN',
    menu: {
      dashboard: 'Dashboard',
      users: 'Benutzer',
      analytics: 'Analytik',
      plans: 'Ernährungspläne',
      influencers: 'Influencer-Codes',
      affiliates: 'Partner',
      discounts: 'Rabatte',
      settings: 'Einstellungen',
    },
    userMenu: {
      profile: 'Admin-Profil',
      settings: 'Systemeinstellungen',
      logout: 'Abmelden',
    },
  },
  dashboard: {
    title: 'Systemübersicht',
    stats: {
      totalUsers: 'Gesamtbenutzer',
      totalRevenue: 'Gesamtumsatz',
      activePlans: 'Aktive Pläne',
      vipBasicRatio: 'VIP/BASIC Verhältnis',
    },
    charts: {
      userGrowth: 'Benutzerwachstum',
      userGrowthSubtitle: 'VIP vs BASIC Benutzer im Zeitverlauf',
      planDistribution: 'Plan-Verteilung',
      refresh: 'Aktualisieren',
    },
  },
  users: {
    title: 'Benutzerverwaltung',
    subtitle: 'Alle Benutzer und Abonnements verwalten',
    search: 'Benutzer suchen...',
    newUser: 'Neuer Benutzer',
    refresh: 'Aktualisieren',
    loading: 'Lade Benutzer...',
    stats: {
      totalUsers: 'Gesamtbenutzer',
      vipUsers: 'VIP-Benutzer',
      basicUsers: 'BASIC-Benutzer',
      activeUsers: 'Aktive Benutzer',
      ofTotal: 'von gesamt',
      completedOnboarding: 'Onboarding abgeschlossen',
    },
    filters: {
      all: 'Alle Pläne',
      vip: 'Nur VIP',
      basic: 'Nur BASIC',
      allStatus: 'Alle Status',
      active: 'Aktiv',
      inactive: 'Ausstehend',
    },
    status: {
      active: 'Aktiv',
      pending: 'Ausstehend',
    },
    table: {
      name: 'Name',
      email: 'E-Mail',
      plan: 'Plan',
      status: 'Status',
      joined: 'Beigetreten',
      actions: 'Aktionen',
      empty: 'Keine Benutzer gefunden',
    },
    actions: {
      edit: 'Bearbeiten',
      view: 'Details anzeigen',
      suspend: 'Sperren',
      delete: 'Löschen',
    },
    bulk: {
      selected: '{{count}} ausgewählt',
      upgradeVIP: 'Auf VIP upgraden',
      downgradeBasic: 'Auf BASIC downgraden',
      delete: 'Löschen',
      clearSelection: 'Auswahl aufheben',
      confirmUpgrade: '{{count}} Benutzer auf VIP upgraden?',
      confirmDowngrade: '{{count}} Benutzer auf BASIC downgraden?',
      confirmDelete: '{{count}} Benutzer dauerhaft löschen?',
      planUpdated: '{{count}} Benutzer erfolgreich aktualisiert',
      deleted: '{{count}} Benutzer erfolgreich gelöscht',
    },
    pagination: {
      showing: 'Zeige {{start}}-{{end}} von {{total}} Benutzern',
    },
    errors: {
      fetchFailed: 'Fehler beim Laden der Benutzer',
      bulkUpdateFailed: 'Massenaktualisierung fehlgeschlagen',
      bulkDeleteFailed: 'Massenlöschung fehlgeschlagen',
    },
    confirmDelete: '{{name}} dauerhaft löschen?',
    confirmSuspend: '{{name}} sperren?',
  },
  modals: {
    userDetails: {
      title: 'Benutzerdetails',
      tabs: {
        profile: 'Profil',
        plan: 'Ernährungsplan',
        progress: 'Fortschritt',
        payments: 'Zahlungen',
      },
    },
    editUser: {
      title: 'Benutzer bearbeiten',
      subtitle: 'Benutzerinformationen aktualisieren',
      fields: {
        name: 'Name',
        email: 'E-Mail',
        plan: 'Plan',
        status: 'Status',
        role: 'Rolle',
      },
      save: 'Änderungen speichern',
      cancel: 'Abbrechen',
    },
    inviteUser: {
      title: 'Neuen Benutzer einladen',
      subtitle: 'Einladungs-E-Mail an neuen Benutzer senden',
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        plan: 'Plan zuweisen',
      },
      send: 'Einladung senden',
      cancel: 'Abbrechen',
    },
    otp: {
      title: 'Aktion bestätigen',
      subtitle: 'Geben Sie Ihren Authentifizierungscode ein',
      placeholder: '6-stelligen Code eingeben',
      verify: 'Bestätigen',
      cancel: 'Abbrechen',
      resend: 'Code erneut senden',
    },
  },
  otp: {
    codeSent: 'Verifizierungscode an Ihre E-Mail gesendet',
    invalidCodeLength: 'Bitte geben Sie einen 6-stelligen Code ein',
    verificationSuccess: 'Verifizierung erfolgreich',
    invalidCode: 'Ungültiger Verifizierungscode',
    verificationFailed: 'Verifizierung fehlgeschlagen',
    actionWarning: 'Sie sind dabei, Benutzer {{action}}: {{targetName}}',
  },
};